// GigWave Icon Components — SVG replicas of original PNG icons
// Place this file at: src/assets/IconComponents.jsx

import { ReactComponent as RequestSongSVG } from './RequestSongIcon.svg';
import { ReactComponent as VoteForASongSVG } from './vote-icon.svg';
import { ReactComponent as RateArtistSVG } from './rate-artist-icon.svg';
import { ReactComponent as ArtistProfileSVG } from './artist-profile-icon.svg';
import { ReactComponent as TipJarSVG } from './tip-jar-icon.svg';
import { ReactComponent as SupportArtistSVG } from './support-artist-icon.svg';

export const RequestSongIcon = ({ size = 250 }) => (
  <RequestSongSVG
    width={size}
    height={size}
    style={{ borderRadius: '18%', display: 'block' }}
  />
);

export const VoteIcon = ({ size = 250 }) => (
  <VoteForASongSVG
    width={size}
    height={size}
    style={{ borderRadius: '18%', display: 'block' }}
  />
);

export const RateArtistIcon = ({ size = 250 }) => (
  <RateArtistSVG
    width={size}
    height={size}
    style={{ borderRadius: '18%', display: 'block' }}
  />
);

export const ArtistProfileIcon = ({ size = 250 }) => (
  <ArtistProfileSVG
    width={size}
    height={size}
    style={{ borderRadius: '18%', display: 'block' }}
  />
);

export const TipJarIcon = ({ size = 250 }) => (
  <TipJarSVG
    width={size}
    height={size}
    style={{ display: 'block' }}
  />
);

export const SupportArtistIcon = ({ size = 250 }) => (
  <SupportArtistSVG
    width={size}
    height={size}
    style={{ display: 'block' }}
  />
);